/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Delete_ConfirmInputs */

const en_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fr_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare`)
};

const ru_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const es_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar`)
};

const zh_cn2_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const ja_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消去`)
};

const hi_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिटाना`)
};

const pt_pt2_image_export_style_preset_delete_confirm = /** @type {(inputs: Image_Export_Style_Preset_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Image_Export_Style_Preset_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_delete_confirm = /** @type {((inputs?: Image_Export_Style_Preset_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_delete_confirm(inputs)
	if (locale === "de") return de_image_export_style_preset_delete_confirm(inputs)
	if (locale === "it") return it_image_export_style_preset_delete_confirm(inputs)
	if (locale === "ru") return ru_image_export_style_preset_delete_confirm(inputs)
	if (locale === "es") return es_image_export_style_preset_delete_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_delete_confirm(inputs)
	if (locale === "ja") return ja_image_export_style_preset_delete_confirm(inputs)
	if (locale === "hi") return hi_image_export_style_preset_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_delete_confirm(inputs)
	return en_image_export_style_preset_delete_confirm(inputs)
});